// extracted by mini-css-extract-plugin
export default {"companyContainer":"gL-z","companyImage":"hL-z","container":"iL-z","heading":"jL-z","darkText":"kL-z","smallHeading":"lL-z","darkBackground":"mL-z","whiteBackground":"nL-z"};